// extracted by mini-css-extract-plugin
var _1 = "Container-module_container__bsATyC";
export { _1 as "container" }
